export default [
  { text: "Name", value: "name" },
  { text: "Default View", value: "views" },
  { text: "Model", value: "forgeModel", width: "300px" },
  { text: "Facility Number", value: "facilityNumber" },
  { text: "Address", value: "address" },
  // { text: 'Building Name', value: 'buildingName' },
  { text: "Created By", value: "createdBy" },
  { text: "Actions", value: "actions", width: "150px" },
];
